import { FC } from 'react';

import TableCell from 'components/Tables/PricingV2/components/TableCell';
import { PricingRowProps, PricingTableConfigProps } from 'components/Tables/PricingV2/config';
import Tooltip from 'components/Tooltip';

type TableRowProps = PricingRowProps &
  Partial<Pick<PricingTableConfigProps, 'tierOneTitle' | 'tierTwoTitle' | 'tierThreeTitle'>>;

const TableRow: FC<TableRowProps> = ({
  rowHeading,
  description,
  tierOne,
  tierTwo,
  tierThree,
  tierOneTitle,
  tierTwoTitle,
  tierThreeTitle,
}) => (
  <tr className="flex items-center border-t border-t-white/20 bg-black/30 px-3 py-4 lg:px-6 lg:py-5">
    <th scope="row" className="w-full p-0 text-left [font-weight:inherit]">
      {description ? (
        <div className="line-clamp-3 text-left text-xl text-white">
          <Tooltip description={description}>{rowHeading}</Tooltip>
        </div>
      ) : (
        <div className="line-clamp-3 text-left text-xl text-white">{rowHeading}</div>
      )}
    </th>
    {tierOne && <TableCell as="td" iconSize={30} planLabel={tierOneTitle} {...tierOne} />}
    {tierTwo && <TableCell as="td" iconSize={30} planLabel={tierTwoTitle} {...tierTwo} />}
    {tierThree && <TableCell as="td" iconSize={30} planLabel={tierThreeTitle} {...tierThree} />}
  </tr>
);

export default TableRow;
